import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

// ── Pre-Dispatch board (staff) ──
export async function getPredispatchBoard() {
  const res = await axios.get(`${API_BASE}/predispatch/board`, { headers: authHeader() });
  return res.data;
}
export async function listPackers() {
  const res = await axios.get(`${API_BASE}/predispatch/packers`, { headers: authHeader() });
  return res.data;
}
export async function assignPackToPacker(pack_id, packer_id) {
  const res = await axios.post(`${API_BASE}/predispatch/assign`, { pack_id, packer_id }, { headers: authHeader() });
  return res.data;
}
export async function getPackReview(pack_id) {
  const res = await axios.get(`${API_BASE}/predispatch/pack/${pack_id}/review`, { headers: authHeader() });
  return res.data;
}
export async function resolvePack(pack_id, resolutions) {
  const res = await axios.post(`${API_BASE}/predispatch/resolve/${pack_id}`, { resolutions }, { headers: authHeader() });
  return res.data;
}

// ── Search queue (staff) ──
export async function getSearchQueue() {
  const res = await axios.get(`${API_BASE}/predispatch/search-queue`, { headers: authHeader() });
  return res.data;
}
export async function searchQueueFound(item_id) {
  const res = await axios.post(`${API_BASE}/predispatch/search-queue/${item_id}/found`, {}, { headers: authHeader() });
  return res.data;
}
export async function searchQueueMarkMissing(item_id) {
  const res = await axios.post(`${API_BASE}/predispatch/search-queue/${item_id}/mark-missing`, {}, { headers: authHeader() });
  return res.data;
}

// ── Packer app (packer) ──
export async function packerMyPacks() {
  const res = await axios.get(`${API_BASE}/predispatch/packer/my-packs`, { headers: authHeader() });
  return res.data;
}
export async function packerPackItems(pack_id) {
  const res = await axios.get(`${API_BASE}/predispatch/packer/pack/${pack_id}`, { headers: authHeader() });
  return res.data;
}
export async function packerSubmitPicks(pack_id, responses) {
  const res = await axios.post(`${API_BASE}/predispatch/packer/pack/${pack_id}/submit`, { responses }, { headers: authHeader() });
  return res.data;
}
export async function packerSearchQueue() {
  const res = await axios.get(`${API_BASE}/predispatch/packer/search-queue`, { headers: authHeader() });
  return res.data;
}
